var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconTravel64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=64, Dark Mode=No",
    clipPath: "url(#clip0_2589_10549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Travel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LineHorz-Copy-4",
    d: "M27 53.5029L27 57.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "LineHorz-Copy-5",
    d: "M37 53.5029V57.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M37 11.5029V9.50293C37 8.39836 36.1046 7.50293 35 7.50293H29C27.8954 7.50293 27 8.39836 27 9.50293L27 11.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.84 11.5029H43.16C45.2808 11.5029 47 13.2727 47 15.4559V49.55C47 51.7331 45.2808 53.5029 43.16 53.5029H20.84C18.7192 53.5029 17 51.7331 17 49.55V15.4559C17 13.2727 18.7192 11.5029 20.84 11.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 45.5029H47V49.2363C47 51.5927 45.2808 53.5029 43.16 53.5029H20.84C18.7192 53.5029 17 51.5927 17 49.2363V45.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "LineHorz-Copy-2",
    d: "M27 18.5029V38.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "LineHorz-Copy-3",
    d: "M37 18.5029V38.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_10549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconTravel64);
export default __webpack_public_path__ + "static/media/pictogramBeaconTravel64.963e67e7f2e6435ead692d7227626a1e.svg";
export { ForwardRef as ReactComponent };